import { useMediaQuery } from './use-media-query';

/** Below Tailwind's `md` breakpoint (48rem = 768px). */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 47.99rem)');
}
